import React from 'react'

const Avatar = ({ name }) => {
  return (
    <div className="initial-img sm c-4">{(name.length > 2) ? name.substring(1, 3) : name}</div>
  )
}

export default Avatar
